import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  DEFAULT_PLATFORM_CONFIG,
  subscribePublicFeatureFlags,
} from "../services/platformConfigService";

const PlatformFeatureFlagsContext = createContext({
  loading: true,
  commentsGloballyEnabled: true,
  newReaderSplitDashboard: true,
});

export function PlatformFeatureFlagsProvider({ children }) {
  const [flags, setFlags] = useState(() => ({ ...DEFAULT_PLATFORM_CONFIG.featureFlags }));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = subscribePublicFeatureFlags((next) => {
      setFlags((prev) => {
        if (
          prev.commentsGloballyEnabled === next.commentsGloballyEnabled &&
          prev.newReaderSplitDashboard === next.newReaderSplitDashboard
        ) {
          return prev;
        }
        return next;
      });
      setLoading(false);
    });
    return unsub;
  }, []);

  const value = useMemo(
    () => ({
      loading,
      commentsGloballyEnabled: flags.commentsGloballyEnabled !== false,
      newReaderSplitDashboard: flags.newReaderSplitDashboard !== false,
    }),
    [loading, flags.commentsGloballyEnabled, flags.newReaderSplitDashboard]
  );

  return (
    <PlatformFeatureFlagsContext.Provider value={value}>{children}</PlatformFeatureFlagsContext.Provider>
  );
}

export function usePlatformFeatureFlags() {
  return useContext(PlatformFeatureFlagsContext);
}
